import React, { useState } from 'react';
import cn from 'classnames';
import { ChevronDown } from 'react-feather';
import { ActionList, Popover } from 'ui';
import { Trophy, OpenBook } from 'ui/Icon/Streamline';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const MobileAppSwitcher = () => {
  const [popoverOpen, setPopoverOpen] = useState(false);

  const buttonClasses = cn(
    'CompanySwitcher-button',
    'border-midnight-30 border-solid c-midnight-100',
    'bg-white d-f bs-n bdrs-4 ai-c minw-150 jc-sb ai-fe',
    {
      'border-midnight-100': popoverOpen,
    },
  );

  return (
    <div className="mr-16">
      <Popover
        isHighPriority
        visible={popoverOpen}
        onClose={() => setPopoverOpen(false)}
        className="CompanySwitcher-popover"
        activator={
          <button
            type="button"
            onClick={() => setPopoverOpen(!popoverOpen)}
            className={buttonClasses}
            aria-label={t('navbar.app_switcher.button_label')}
          >
            <div className="d-f fd-c ai-fs ov-h">
              <Text
                variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
                className="pb-8"
              >
                {t('navbar.app_switcher.app')}
              </Text>
              <div className="d-f ai-c">
                <OpenBook width={19} height={15} />
                <div className="ml-8 lh-24 fz-14">
                  {t('navbar.app_switcher.training')}
                </div>
              </div>
            </div>
            <ChevronDown size={16} className="ml-16 f-sh-0" />
          </button>
        }
      >
        <div className="bdrs-4 f-o-n bg-white pt-8 pb-6 bs-3 minw-150">
          <ActionList
            items={[
              {
                content: (
                  <>
                    <OpenBook width={19} height={15} />
                    <span
                      className="ml-8"
                      title={t('navbar.app_switcher.training')}
                    >
                      {t('navbar.app_switcher.training')}
                    </span>
                  </>
                ),
                url: '/',
              },
              {
                content: (
                  <>
                    <Trophy width={19} height={15} />
                    <span
                      className="ml-8"
                      title={t('navbar.app_switcher.skills')}
                    >
                      {t('navbar.app_switcher.skills')}
                    </span>
                  </>
                ),
                url: '/skills',
              },
            ]}
          />
        </div>
      </Popover>
    </div>
  );
};

export default props => <MobileAppSwitcher {...props} />;
